// extracted by mini-css-extract-plugin
export var button = "_ld-0";
export var donut = "_ld-1";
export var donutFill = "_ld-3";
export var donutTrack = "_ld-2";